import "./Contact.css";
import { useState } from "react";
import { sendContact } from "../../services/contactService";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import { Helmet } from "react-helmet";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const validate = () => form.email.trim() && form.message.trim();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setStatus("error");
      setErrorMsg("Please provide at least Email and Message.");
      return;
    }
    try {
      setStatus("loading");
      setErrorMsg("");
      const resp = await sendContact({
        name: form.name.trim(),
        email: form.email.trim(),
        subject: form.subject.trim(),
        message: form.message.trim(),
      });
      // Backend zwraca: { "detail": "Your email has been sent successfully." }
      setStatus("success");
      setErrorMsg("");
      // opcjonalnie reset
      // setForm({ name:"", email:"", subject:"", message:"" });
    } catch (err) {
      setStatus("error");
      setErrorMsg(err?.message || "Something went wrong. Try again.");
    }
  };

  return (
    <main className="contact-page">
      <Helmet>
        <title>GlobTel Esim - Contact</title>
      </Helmet>

      <PageHeader
        title="Contact Us"
        description=" Tell us about your use case. The team responds quickly with practical
          next steps."
      />

      <section className="contact-page__wrap">
        <form
          className="contact-form"
          onSubmit={onSubmit}
          noValidate
          aria-labelledby="contactFormTitle"
        >
          <h2 id="contactFormTitle" className="sr-only">
            Contact form
          </h2>

          <div className="field">
            <label htmlFor="name">Name</label>
            <input
              id="name"
              name="name"
              type="text"
              value={form.name}
              onChange={onChange}
              placeholder="Jane Doe"
              autoComplete="name"
            />
          </div>

          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={form.email}
              onChange={onChange}
              placeholder="jane@company.com"
              required
              aria-required="true"
              autoComplete="email"
            />
          </div>

          <div className="field">
            <label htmlFor="subject">Subject</label>
            <input
              id="subject"
              name="subject"
              type="text"
              value={form.subject}
              onChange={onChange}
              placeholder="Partnership inquiry"
            />
          </div>

          <div className="field">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows={6}
              value={form.message}
              onChange={onChange}
              placeholder="Tell us briefly about your needs…"
              required
              aria-required="true"
            />
          </div>

          <div className="actions">
            <button
              type="submit"
              className="btn btn--primary"
              disabled={status === "loading"}
            >
              {status === "loading" ? "Sending…" : "Send Message"}
            </button>
            {status === "success" && (
              <span className="note ok" role="status" aria-live="polite">
                Thanks! We’ll reply shortly.
              </span>
            )}
            {status === "error" && (
              <span className="note err" role="alert" aria-live="assertive">
                {errorMsg || "Something went wrong. Try again."}
              </span>
            )}
          </div>
        </form>

        <aside className="contact-info" aria-label="Offices">
          <div className="info-card">
            <h3>Office in Berlin</h3>
            <p>+49 30 22957331</p>
            <p>Westhafenstr. 1 13353 Berlin, Germany</p>
          </div>
          <div className="info-card">
            <h3>Office in Warsaw</h3>
            <p>+48 22 213 39 00</p>
            <p>ul. Skierniewicka 16/20 01-230 Warszawa, Polska</p>
          </div>
          <div className="map-card" aria-label="Map">
            <div className="map-embed">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2443.6915810329447!2d20.966788440951465!3d52.23082097210332!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecb625288163b%3A0xda1205c87f6c6d0a!2sSkierniewicka%2016%2F20%2C%2001-230%20Warszawa!5e0!3m2!1sen!2sus!4v1757510579931!5m2!1sen!2sus"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </aside>
      </section>
    </main>
  );
}
